<template>
  <div class="article">
    <h1 class="site-title">Nati King</h1>
    <ArticleComponent :postID="articleID" />
  </div>
</template>

<script src="./article.ts"></script>
<style src="./article.scss" lang="scss"></style>
